import service from '@/api/service/service';
import qs from "qs";

// 个人设置详情
export function getPersonSetInfo(params = {}) {
  return service({
    url: '/api/user/my_page.json',
    method: 'get',
    params,
  })
}

// 个人设置修改
export function postEditPersonSet(data = {}) {
  return service({
    url: '/api/user/my_page_ajax.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 个人设置中发送手机验证码
export function postPhoneCode(data = {}) {
  return service({
    url: '/api/user/send_verify_code.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 个人设置中修改手机号
export function postPhoneNum(data = {}) {
  return service({
    url: '/api/user/amend_phone.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 个人设置中修改密码
export function postPassword(data = {}) {
  return service({
    url: '/api/user/amend_password.json',
    method: 'post',
    data: qs.stringify(data),
  })
}